'use client'

import { useCallback } from 'react'

import { useMaestroSession } from '@maestro/commerce-blocks/providers/maestro-session/maestro-session.context'
import { clearUserStorage } from '@maestro/commerce-blocks/utils/clear-user-storage.utils'
import { safeLogoutRedirect } from '@maestro/commerce-blocks/utils/logout.utils'
import { useEventBusContext } from '@maestro/core/event/event-bus.context'
import { EventPayloadType, EventType, type User } from '@maestro/data-layer'

export const useSignOut = () => {
  const { publish } = useEventBusContext()
  const { session } = useMaestroSession()

  const handleSignOut = useCallback(async () => {
    const user = session?.user as User | undefined

    const payload: EventPayloadType[EventType.USER_LOGGED_OUT] = {
      user_id: user?.id,
      user_data: {
        email_address: user?.email,
        phone_number: user?.phone,
        first_name: user?.name,
        last_name: user?.lastName,
        street: user?.defaultAddress?.line1,
        city: user?.defaultAddress?.town,
        region: undefined,
        postal_code: user?.defaultAddress?.postalCode,
        country: user?.defaultAddress?.country?.name,
        total_order_count: user?.orderCount || 0,
        total_lifetime_value: user?.orderTotals || 0,
      },
    }

    clearUserStorage()
    publish<EventPayloadType[EventType.USER_LOGGED_OUT]>(
      EventType.USER_LOGGED_OUT,
      payload
    )
    safeLogoutRedirect()
  }, [publish, session?.user])

  return { handleSignOut }
}
